//  document.addEventListener('DOMContentLoaded', function () {
//     const selectSizeElement = document.querySelector('.select-size');
//     const selectColorElement = document.querySelector('.select-color');
//     function autoSelectAvailableOption(selectElement) {
//         const availableOption = selectElement.querySelector('.opt-available');
//         if (availableOption) {
//             availableOption.selected = true;
//         }
//     }
//     autoSelectAvailableOption(selectSizeElement);
//     autoSelectAvailableOption(selectColorElement);

//     // Listen for changes on size select
//     selectSizeElement.addEventListener('change', function () {
//         autoSelectAvailableOption(selectSizeElement);
//     });

//     // Listen for changes on color select
//     selectColorElement.addEventListener('change', function () {
//       // const selectedOption = this.options[this.selectedIndex];
    
//         autoSelectAvailableOption(selectColorElement);
//     });
// });


console.log("Custom js is working");
// code for transparent header
 const request_page = document.body.getAttribute('data-template-name');
if(request_page == 'index') {
   if (window.innerWidth > 767) {
  document.querySelector(".header__heading-logo-wrapper img").style.opacity = '0';
   }
}
document.addEventListener('DOMContentLoaded', () => {
  const request_page_type = document.body.getAttribute('data-template-name');
  if (request_page_type === 'index') {
    const megaMenus = document.querySelectorAll('.mega-menu');
    const menudrawer = document.querySelector('.menu-drawer-container');
    const headerWrapper = document.querySelector('.header-wrapper');
    const firstSection = document.querySelector('#MainContent .shopify-section');

    // Check if any mega menu is open
    const isMegaMenuOpen = () => Array.from(megaMenus).some(menu => menu.hasAttribute('open'));

    // Check if the menu drawer is open (Shopify uses aria-expanded)
    const isMenuDrawerOpen = () => {
      const drawerToggle = document.querySelector('[aria-controls="menu-drawer"]');
      return drawerToggle && drawerToggle.getAttribute('aria-expanded') === 'true';
    };

    // Update header styling class based on menu and section visibility
    const updateHeaderStyle = () => {
      const isAnyMenuOpen = isMegaMenuOpen() || isMenuDrawerOpen();
      const isFirstSectionVisible = document.body.classList.contains('first-section-visible');

      if (isAnyMenuOpen && isFirstSectionVisible) {
        document.body.classList.add('menu-open-dark-on-light');
      } else {
        document.body.classList.remove('menu-open-dark-on-light');
      }
    };

    // Mutation Observer for mega menus
    megaMenus.forEach(menu => {
      const observer = new MutationObserver(updateHeaderStyle);
      observer.observe(menu, { attributes: true, attributeFilter: ['open'] });
    });

    // Mutation Observer for menu drawer (watching aria-expanded)
    const drawerToggle = document.querySelector('[aria-controls="menu-drawer"]');
    if (drawerToggle) {
      const drawerObserver = new MutationObserver(updateHeaderStyle);
      drawerObserver.observe(drawerToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    // Intersection Observer to detect if first section is in viewport
    if (firstSection) {
      const sectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            document.body.classList.add('first-section-visible');
          } else {
            document.body.classList.remove('first-section-visible');
          }
          updateHeaderStyle(); // run again on section visibility change
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      sectionObserver.observe(firstSection);
    }
  }
});
